export let MessageCategory;

(function (MessageCategory) {
  MessageCategory["PLAIN_TEXT"] = "PLAIN_TEXT";
  MessageCategory["PLAIN_STICKER"] = "PLAIN_STICKER";
  MessageCategory["PLAIN_IMAGE"] = "PLAIN_IMAGE";
  MessageCategory["PLAIN_AUDIO"] = "PLAIN_AUDIO";
  MessageCategory["PLAIN_VIDEO"] = "PLAIN_VIDEO";
  MessageCategory["PLAIN_CONTACT"] = "PLAIN_CONTACT";
  MessageCategory["APP_CARD"] = "APP_CARD";
  MessageCategory["PLAIN_DATA"] = "PLAIN_DATA";
  MessageCategory["PLAIN_LIVE"] = "PLAIN_LIVE";
  MessageCategory["PLAIN_LOCATION"] = "PLAIN_LOCATION";
  MessageCategory["PLAIN_POST"] = "PLAIN_POST";
  MessageCategory["APP_BUTTON_GROUP"] = "APP_BUTTON_GROUP";
  MessageCategory["SYSTEM_ACCOUNT_SNAPSHOT"] = "SYSTEM_ACCOUNT_SNAPSHOT";
  MessageCategory["MESSAGE_PIN"] = "MESSAGE_PIN";
})(MessageCategory || (MessageCategory = {}));